import { App } from 'data/terra/App';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import {
  FetchResourceAction,
  fetchResourceDelegate,
  Resource,
  ResourceActionTypes,
} from 'v2/store/common/Resource';
import { ProjectDetailState } from '../state';
import { selectApp } from './SelectApp';

const ActionTypes: ResourceActionTypes = {
  requestFetching: 'project/apps/fetch',
  fetchSuccess: 'project/apps/fetchSuccess',
  fetchFailure: 'projectt/apps/fetchFailure',
};

export type FetchAppsAction = FetchResourceAction<App[]>;

export const fetchAppsForCurrentProject = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async (dispatch, getState) => {
  const projectId = getState().projectDetail.project.data?.id;

  if (projectId) {
    dispatch(fetchApps(projectId));
  }
};

export const fetchApps = (
  projectId: string
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  dispatch({
    type: ActionTypes.requestFetching,
  } as FetchAppsAction);

  const result = await Terra.app.fetchApps(projectId);

  if (result.isSuccess()) {
    const apps = result.get()!.data;
    dispatch({
      type: ActionTypes.fetchSuccess,
      data: apps,
    } as FetchAppsAction);
    if (apps.length > 0) {
      dispatch(selectApp(apps[0].id));
    }
  } else {
    dispatch({
      type: ActionTypes.fetchFailure,
      error: result.exception(),
    } as FetchAppsAction);
  }
};

export const fetchAppsDelegate = fetchResourceDelegate<
  ProjectDetailState,
  App[]
>(
  ActionTypes,
  (
    rootState: ProjectDetailState,
    reduce: (state: Resource<App[]>) => Resource<App[]>
  ) => {
    return {
      ...rootState,
      apps: reduce(rootState.apps),
    };
  }
);
